import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';
import { addPrefixPath } from '@serpro/volto-prefixpath/helpers/Url/Url';

export const getVideoFileSource = (file) => {
  if (!file) return null;

  if (file.download) {
    return addPrefixPath(file.download);
  }

  if (file['@id']) {
    return addPrefixPath(file['@id']);
  }

  if (file.data) {
    const encoding = file.encoding || 'base64';
    const mimeType =
      file['content-type'] ||
      file.content_type ||
      file.contentType ||
      'video/mp4';
    return `data:${mimeType};${encoding},${file.data}`;
  }

  return null;
};

export const buildVideoUrlFromFile = (file) => {
  const source = getVideoFileSource(file);
  if (!source) return null;
  if (source.startsWith('data:video/')) return source;
  if (!file?.filename) return null;
  return `${source}/${file.filename}`;
};

export const getSelectedUrlItem = (urlValue) => {
  if (Array.isArray(urlValue)) return urlValue[0] || null;
  if (urlValue && typeof urlValue === 'object') return urlValue;
  return null;
};

export const getSelectedVideoPath = (selectedVideoItem) => {
  return selectedVideoItem?.['@id'] && isInternalURL(selectedVideoItem['@id'])
    ? flattenToAppURL(selectedVideoItem['@id'])
    : null;
};

export const getSelectedExternalUrlFromItem = (selectedVideoItem) => {
  return selectedVideoItem?.['@id'] && !isInternalURL(selectedVideoItem['@id'])
    ? selectedVideoItem['@id']
    : '';
};

export const normalizeLegacyUrlValue = (urlValue) => {
  if (typeof urlValue !== 'string') return null;
  const trimmed = urlValue.trim();
  if (!trimmed) return null;

  const normalizedId = isInternalURL(trimmed)
    ? flattenToAppURL(trimmed)
    : trimmed;

  return [{ '@id': normalizedId, title: trimmed }];
};

export const getVideoSubrequestId = (block, selectedVideoPath, fallback) => {
  if (block) return `video-block-${block}-selected-video`;
  if (selectedVideoPath) {
    return `video-block-${encodeURIComponent(selectedVideoPath)}-selected-video`;
  }
  return `video-block-${fallback}-selected-video`;
};
